import { render, staticRenderFns } from "./Multichat.vue?vue&type=template&id=bc908bf0&scoped=true&"
import script from "./Multichat.vue?vue&type=script&lang=js&"
export * from "./Multichat.vue?vue&type=script&lang=js&"
import style0 from "./Multichat.vue?vue&type=style&index=0&id=bc908bf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc908bf0",
  null
  
)

export default component.exports